import { Check } from 'lucide-react'
import { useProfileQuery } from '@entities/user'
import { useAppStore } from '@/store/useAppStore'
import styles from './ProfileLoginMethods.module.css'

// EU-сервис: без Telegram-слоя. Код TG-привязки сохранён закомментированным.
// import { useState } from 'react'
// import { ENV } from '@shared/config/env'
// import { usePlatform, prepareAsyncOpenTab } from '@shared/platform'
// import { LinkEmailModal } from '@features/link-email/ui/LinkEmailModal'
// import { LinkTelegramWaitModal } from '@features/link-telegram/ui/LinkTelegramWaitModal'
// import { generateLinkTelegram } from '@features/link-telegram/api/linkTelegramApi'

/**
 * Блок «Sign-in» в профиле. EU-сервис: авторизация только по email,
 * Telegram-привязки нет (код сохранён закомментированным ниже).
 */
export const ProfileLoginMethods = () => {
  const profileFromStore = useAppStore((s) => s.profile)
  const { data } = useProfileQuery(true)
  const profile = data ?? profileFromStore
  const email = profile?.email?.email

  // --- Telegram-привязка (EU: отключено) ---
  // const platform = usePlatform()
  // const [linkEmailOpen, setLinkEmailOpen] = useState(false)
  // const [waitTgOpen, setWaitTgOpen] = useState(false)
  // const [tgError, setTgError] = useState<string | null>(null)
  //
  // const handleLinkTelegram = async () => {
  //   setTgError(null)
  //   const tab = prepareAsyncOpenTab(platform)
  //   try {
  //     const { link } = await generateLinkTelegram()
  //     tab.complete(link)
  //     setWaitTgOpen(true)
  //   } catch {
  //     tab.abort()
  //     setTgError('Couldn’t generate the link. Please try again later.')
  //   }
  // }
  //
  // const telegramLabel = profile?.telegram
  //   ? profile.telegram.username
  //     ? `@${profile.telegram.username}`
  //     : [profile.telegram.first_name, profile.telegram.last_name].filter(Boolean).join(' ')
  //   : null
  // const tgLinked = Boolean(profile?.telegram)
  // const showTgLinkButton = !tgLinked && ENV.IS_WEB

  return (
    <section className={styles.section}>
      <h3 className={styles.title}>Sign-in</h3>

      <div className={styles.row}>
        <div className={styles.info}>
          <div className={styles.labelRow}>
            <span className={styles.label}>Email</span>
            {email && (
              <Check
                className={styles.check}
                size={20}
                strokeWidth={2.5}
                aria-hidden="true"
              />
            )}
          </div>
          {email && <span className={styles.value}>{email}</span>}
        </div>
      </div>

      {/* EU-сервис: Telegram-способ входа отключён (разметка сохранена).
      <div className={`${styles.row} ${showTgLinkButton ? styles.rowUnlinked : ''}`}>
        <div className={styles.info}>
          <div className={styles.labelRow}>
            <span className={styles.label}>Telegram</span>
            {tgLinked && <Check className={styles.check} size={20} strokeWidth={2.5} aria-hidden="true" />}
          </div>
          {tgLinked && telegramLabel && <span className={styles.value}>{telegramLabel}</span>}
        </div>
        {showTgLinkButton && (
          <button type="button" className={styles.linkButton} onClick={handleLinkTelegram}>
            Link
          </button>
        )}
      </div>
      {tgError && <div className={styles.error}>{tgError}</div>}
      {linkEmailOpen && <LinkEmailModal onClose={() => setLinkEmailOpen(false)} />}
      {waitTgOpen && <LinkTelegramWaitModal onClose={() => setWaitTgOpen(false)} />}
      */}
    </section>
  )
}
